import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MenuItem } from "primeng/api";

@Component({
  selector: 'app-financial-settings',
  templateUrl: './financial-settings.component.html',
  styleUrls: ['./financial-settings.component.css'],
})
export class FinancialSettingsComponent implements OnInit {
  settingsMenuItems: MenuItem[];
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));

  constructor(private router: Router) {}

  checkActiveState(givenLink) {
    if (this.router.url.indexOf(givenLink) === -1) {
      return false;
    } else {
      return true;
    }
  }

  ngOnInit() {
    this.settingsMenuItems = [
      {
        label: "Fines",
        icon: "fa fa-money",
        routerLink: ["/pages/financial/settings/fines"],
        expanded: this.checkActiveState("/pages/financial/settings/fines"),
      },
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/financial-settings/components/financial-settings/financial-settings.component.ts